module.exports = __webpack_public_path__ + "img/陕西师范大学.321e0c2e.png";